export default __webpack_public_path__ + "static/media/lightIconEmpty.e7240d2d.svg";